import React, { useState } from 'react';
import { Box, Typography } from '@material-ui/core';
import { Modal, Uploader, Button, Alert } from 'rsuite';
import InputElement from '../MUIInputElement';
import { cuotitasStoreService } from '../../services';
import createCommerceMultipart from '../../helpers/CreateCommerceMultipart';
import FormikWrapper from '../FormikWrapper';
import * as yup from 'yup';

const commerceRegistrationModel = {
    commerceName: {
        name: 'commerceName',
        label: 'Nombre',
        required: true,
        requiredErrorMessage: 'Campo requerido',
        invalidErrorMessage: '',
    },
    commerceCuit: {
        name: 'commerceCuit',
        label: 'Cuit ',
        required: true,
        requiredErrorMessage: 'Campo requerido',
        invalidErrorMessage: 'Por favor ingresa un Cuit válido',
    },
    commerceCode: {
        name: 'commerceCode',
        label: 'Código',
        required: true,
        requiredErrorMessage: 'Campo requerido',
        invalidErrorMessage: 'Por favor ingresa un Código válido',
    },
    commerceUnit: {
        name: 'commerceUnit',
        label: 'Unidad de negocio',
        required: true,
        requiredErrorMessage: 'Campo requerido',
    },
    commerceProvince: {
        name: 'commerceProvince',
        label: 'Provincia',
        requiredErrorMessage: 'Campo requerido para la dirección',
    },
    commerceLocation: {
        name: 'commerceLocation',
        label: 'Localidad',
        requiredErrorMessage: 'Campo requerido para la dirección',

    },
    commerceStreet: {
        name: 'commerceStreet',
        label: 'Calle',
        requiredErrorMessage: 'Campo requerido para la dirección',
    },
    commerceStreetNumber: {
        name: 'commerceStreetNumber',
        label: 'Nro',
        requiredErrorMessage: 'Campo requerido para la dirección',
    },
    commerceFloor: {
        name: 'commerceFloor',
        label: 'Piso',
        requiredErrorMessage: 'Complete todos los campos de la dirección para ingresar el piso'
    },

    commercePostalCode: {
        name: 'commercePostalCode',
        label: 'Código Postal',
        requiredErrorMessage: 'Campo requerido para la dirección',
    },
    commerceType: {
        name: 'commerceType',
        label: 'Rubro',
    },
    commerceEmail: {
        name: 'commerceEmail',
        label: 'Email',
    },
    commerceNumber: {
        name: 'commerceNumber',
        label: 'Número de telefono',
    },
    commerceFiles: {
        name: 'commerceFiles',
    },
};

const {
    commerceName,
    commerceCuit,
    commerceProvince,
    commerceLocation,
    commerceStreet,
    commerceStreetNumber,
    commerceFloor,
    commercePostalCode,
    commerceType,
    commerceEmail,
    commerceNumber,
    commerceUnit,
    commerceCode
} = commerceRegistrationModel;

const commerceRegistrationInitialState = {
    [commerceName.name]: '',
    [commerceCuit.name]: '',
    [commerceProvince.name]: '',
    [commercePostalCode.name]: '',
    [commerceFloor.name]: '',
    [commerceStreetNumber.name]: '',
    [commerceStreet.name]: '',
    [commerceLocation.name]: '',
    [commerceType.name]: '',
    [commerceEmail.name]: '',
    [commerceNumber.name]: '',
    [commerceCode.name]: '',
    [commerceUnit.name]: ''
};

const phoneRegExp = /^((\\+[1-9]{1,4}[ \\-]*)|(\\([0-9]{2,3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/;

const commerceRegistrationValidationSchema = yup.object().shape({
    [commerceName.name]: yup.string()
        .max(200, 'El nombre ingresado es demasiado largo')
        .required(commerceName.requiredErrorMessage),
    [commerceCuit.name]: yup.number()
        .test('len', 'El Cuit ingresado no es válido', val => !val || (val && val.toString().length === 11))
        .positive(commerceCuit.invalidErrorMessage)
        .integer(commerceCuit.invalidErrorMessage)
        .typeError(commerceCuit.invalidErrorMessage)
        .required(commerceCuit.requiredErrorMessage),
    [commerceCode.name]: yup.number()
        .positive(commerceCode.invalidErrorMessage)
        .integer(commerceCode.invalidErrorMessage)
        .typeError(commerceCode.invalidErrorMessage)
        .required(commerceCode.requiredErrorMessage),
    [commerceUnit.name]: yup.string()
        .required(commerceCode.requiredErrorMessage)
        .max(100, 'La información ingresada es demasiado larga'),
    [commerceProvince.name]: yup.lazy(() => yup.string()
        .max(100, 'La dirección ingresada es demasiado larga')
        .when(['commerceStreet', 'commercePostalCode', 'commerceLocation', 'commerceStreetNumber'], {
            is: (street, postalCode, location, streetNumber) => street || postalCode || location || streetNumber,
            then: yup.string().required(commerceProvince.requiredErrorMessage),
            otherwise: yup.string()
        })),
    [commerceLocation.name]: yup.lazy(() => yup.string()
        .when(['commerceProvince', 'commerceStreet', 'commercePostalCode', 'commerceStreetNumber'], {
            is: (province, street, postalCode, streetNumber) => province || street || postalCode || streetNumber,
            then: yup.string().required(commerceLocation.requiredErrorMessage),
            otherwise: yup.string()
        })
        .max(100, 'La dirección ingresada es demasiado larga')),
    [commerceStreet.name]: yup.lazy(() => yup.string()
        .when(['commerceProvince', 'commercePostalCode', 'commerceLocation', 'commerceStreetNumber'], {
            is: (province, postalCode, location, streetNumber) => province || postalCode || location || streetNumber,
            then: yup.string().required(commerceStreet.requiredErrorMessage),
            otherwise: yup.string()
        })
        .max(30, 'La dirección ingresada es demasiado larga')),
    [commerceStreetNumber.name]: yup.lazy(() => yup.string()
        .when(['commerceProvince', 'commercePostalCode', 'commerceStreet', 'commerceLocation'], {
            is: (province, postalCode, street, location) => province || postalCode || street || location,
            then: yup.string().required(commerceStreetNumber.requiredErrorMessage),
            otherwise: yup.string()
        })
        .max(30, 'La dirección ingresada es demasiado larga')),
    [commerceFloor.name]: yup.lazy(() => yup.string()
        .max(10, 'La dirección ingresada es demasiado larga')),
    [commercePostalCode.name]: yup.lazy(() => yup.string()
        .when(['commerceProvince', 'commerceStreet', 'commerceStreetNumber', 'commerceLocation'], {
            is: (province, street, streetNumber, location) => province || street || streetNumber || location,
            then: yup.string().required(commercePostalCode.requiredErrorMessage),
            otherwise: yup.string()
        })
        .max(10, 'La dirección ingresada es demasiado larga')),
    [commerceType.name]: yup.string()
        .max(100, 'El rubro ingresado es demasiado largo'),
    [commerceEmail.name]: yup.string()
        .email('Introduce un email válido')
        .max(254, 'El email ingresado es demasiado largo'),
    [commerceNumber.name]: yup.string()
        .matches(phoneRegExp, 'El número ingresado no es válido')
        .min(8, 'El número ingresado es demasiado corto')
        .max(16, 'el número ingresado es demasiado largo')
});

const CreateCommerceDialog = ({ show, onHide }) => {
    const [fileList, setFileList] = useState([]);
    const [isLoading, setIsLoading] = useState(false);

    const handleChange = files => {
        setFileList(files);
    };

    const handleRemove = file => {
        const newFileList = fileList.filter(f => f.name !== file.name);
        setFileList(newFileList);
    };

    const handleSubmit = values => {
        setIsLoading(true);
        const formData = createCommerceMultipart(values, fileList);
        cuotitasStoreService
            .createMultipart(formData)
            .then(res => {
                onHide();
                Alert.success('La información se guardo correctamente', 3000);
            })
            .catch(e => {
                Alert.error('Se produjo un problema, por favor intentá de nuevo más tarde', 3000);
            })
            .finally(() => {
                setIsLoading(false);
            });
    };

    return (
        <Modal
            show={show}
            onHide={onHide}
            className={`${show ? 'show in' : ''} modal-responsive`}
            aria-labelledby='commerce-create-modal'
            size='lg'
        >
            <Modal.Header closeButton>
                <Modal.Title id='commerce-create-modal'>
                    {!isLoading && (<span>Nuevo Comercio</span>)}
                    {isLoading && <span>Creando Comercio...</span>}
                </Modal.Title>
            </Modal.Header>
            <FormikWrapper
                initialValues={commerceRegistrationInitialState}
                validationSchema={commerceRegistrationValidationSchema}
                handleSubmit={handleSubmit}
                id="commerceRegistrationForm"
            >
                <Modal.Body className='h-100'>
                    {!isLoading && (
                        <Box>
                            <Box
                                sx={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    alignItems: 'center',
                                }}
                            >
                                <Typography variant="h5">Datos de la empresa</Typography>
                                <Box sx={{ marginTop: 15 }}>
                                    <InputElement label={commerceName.label} name={commerceName.name} />
                                    <InputElement label={commerceCuit.label} name={commerceCuit.name} />
                                    <InputElement label={commerceUnit.label} name={commerceUnit.name} />
                                    <InputElement label={commerceCode.label} name={commerceCode.name} />
                                    <InputElement label={commerceEmail.label} name={commerceEmail.name} />
                                    <InputElement label={commerceNumber.label} name={commerceNumber.name} />
                                    <InputElement label={commerceType.label} name={commerceType.name} />
                                    <InputElement label={commerceProvince.label} name={commerceProvince.name} />
                                    <InputElement label={commerceLocation.label} name={commerceLocation.name} />
                                    <InputElement label={commercePostalCode.label} name={commercePostalCode.name} />
                                    <InputElement label={commerceStreet.label} name={commerceStreet.name} />
                                    <InputElement label={commerceStreetNumber.label} name={commerceStreetNumber.name} />
                                </Box>
                                <Box
                                    sx={{
                                        mt: '30px',
                                        display: 'flex',
                                        flexDirection: 'column',
                                        alignItems: 'center',
                                    }}
                                >
                                    <Uploader
                                        multiple
                                        disabled={isLoading || fileList.length === 10}
                                        fileList={fileList}
                                        autoUpload={false}
                                        onRemove={file => handleRemove(file)}
                                        onChange={files => handleChange(files)}
                                    >
                                        <div>Haga Click para cargar sus archivos</div>
                                    </Uploader>
                                    <Box
                                        sx={{
                                            display: `${fileList.length === 10 ? 'block' : 'none'}`,
                                            color: 'red',
                                        }}
                                    >
                                        Máximo de archivos permitidos alcanzado
                                    </Box>
                                </Box>
                            </Box>
                        </Box>
                    )}
                </Modal.Body>
                <Modal.Footer className='mt-4'>
                    <div>
                        <Button appearance='primary' disabled={isLoading} type='submit'>Aceptar</Button>
                        <Button appearance='subtle' disabled={isLoading} onClick={onHide}>Cancelar</Button>
                    </div>
                </Modal.Footer>
            </FormikWrapper>
        </Modal>
    );
};

export default CreateCommerceDialog;
